import DropMenu, {DropMenuTrigger} from '@/components/DropMenu';
import {useIntl} from 'react-intl';
import * as store from '@/store';
import sdk from '@/sdk';
import {tocRouters} from '@/config/routers';
import {useHistory} from 'react-router';
import Avatar, {AvatarSize} from '@/components/Avatar';
import classNames from 'classnames';
import styles from './index.module.scss';
import {feLogger, homePageEntry} from '@/buried';
import {useRouteMatch} from 'react-router-dom';
import {useVerifyEditorDialog} from '@/domains/document/DocHome/Document/Dialogs/useVerifyEditorDialog';

function AvatarDropMenu() {
    const intl = useIntl();
    const history = useHistory();
    const isHomePage = !!useRouteMatch({path: tocRouters.Welcome.path, exact: true}); // 是否首页
    const mode = store.getDocumentMode();

    const {VerifyEditorDialog, verifiedEvents} = useVerifyEditorDialog(false, mode);

    function handleLogout() {
        sdk.as.userLogOut();
    }

    async function handleOpenHomePage() {
        feLogger(homePageEntry);
        isHomePage && location.reload();
        !isHomePage && history.push(tocRouters.Welcome.path);
    }

    const avatarOptions = [
        // {
        //     label: intl.formatMessage({id: 'labelHomePage'}),
        //     value: 'homePage',
        //     onClick: handleOpenHomePage,
        // },
        {
            label: intl.formatMessage({id: 'labelHeadLogout'}),
            value: 'document',
            onClick: verifiedEvents(handleLogout),
        },
    ];

    return <>
        <DropMenu
            triggerType={DropMenuTrigger.Hover}
            options={avatarOptions.filter((data: any) => data.visible !== false)}
            className={classNames(styles.avatarDropMenu, 'avatarDropMenu')}
            placement={'bottom-end'}
        >
            <div className={styles.avatarDiv}>
                {sdk.as.user && (
                    <Avatar
                        className={styles.avatarWrap}
                        userGuid={sdk.as.user?.userGuid}
                        size={AvatarSize.XS}
                    />
                )}
            </div>
        </DropMenu>
        <VerifyEditorDialog />
    </>;
}

export default AvatarDropMenu;


